import type { NetGame } from '@orb/net';
import { copyText } from './Menu';

/**
 * Online only: a small badge with the room code (tap to copy an invite link), the connection state
 * and the round trip. The full lobby UI comes with stage 5.
 */
/** `link`: the room's invite link (never built from location.href: in Telegram it carries the signed launch data). */
export function mountNetStatus(host: HTMLElement, net: NetGame, link: (code: string) => string) {
  const el = document.createElement('button');
  el.type = 'button'; el.className = 'net-status with-menu';
  el.addEventListener('pointerdown', (e) => e.stopPropagation());
  el.addEventListener('click', (e) => {
    e.stopPropagation();
    void copyText(link(net.room?.code ?? '')).then((ok) => { if (ok) { el.dataset.copied = '1'; setTimeout(() => delete el.dataset.copied, 1200); } });
  });
  // in the battle's corner row, beside the menu button (never on top of it)
  const bar = host.querySelector('.menu-bar');
  if (bar) bar.append(el); else host.append(el);
  let last = '';
  const update = () => {
    const s = net.link.state, rtt = net.link.rtt;
    const text = `${net.room?.code ?? '…'} · ${net.lockstep?.gap ? 'потрібна синхронізація' : s === 'open' ? (Number.isNaN(rtt) ? '…' : `${Math.round(rtt)} мс`) : s === 'offline' ? 'немає зв’язку' : s === 'closed' ? 'відключено' : 'з’єднання…'}`;
    if (text !== last) { el.textContent = text; el.dataset.state = s; el.title = 'Код кімнати · натисніть, щоб скопіювати запрошення'; last = text; }
  };
  update();
  setInterval(update, 500);
}
